import { render, staticRenderFns } from "./Consegna.vue?vue&type=template&id=35af9598"
import script from "./Consegna.vue?vue&type=script&lang=js"
export * from "./Consegna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports